import {ApiV0ResourceManager} from '../api.v0.resource-manager';
import {RestApiService} from '../../../rest-api.service';
import {BaseCollectionModel} from '@yasc/yasc-material-components';
import {
    CalendarStatsQueryReq,
    CalendarYearStatContractRes
} from '../../../../contracts/v0/resource-manager/calendar-stat.contract';
import {
    CalendarApprovalBatchReq,
    CalendarApprovalSearchReq
} from '../../../../contracts/v0/resource-manager/calendar-approval.contract';
import {
    CalendarEntryCreateBatchReq,
    CalendarEntryCreateTypedReq,
    CalendarEntryQueryReq,
    CalendarEntryRes,
    CalendarEntryUReq,
    CalendarInvitationRespondReq,
    CalendarMissingEntriesAggregationRes,
    CalendarMissingEntriesGroupingRes,
    CalendarMissingEntriesUserRes,
    CalendarMissingEntrySearchReq
} from '../../../../contracts/v0/resource-manager/calendar.contracts';

export class ApiV0RmCalendar {
    segment: string

    constructor(v0: ApiV0ResourceManager, private api: RestApiService) {
        this.segment = v0.segment + "/calendar";
    }

    /** GET /calendar/entries */
    public list(query: CalendarEntryQueryReq) {
        // forward query as-is
        return this.api.post<CalendarEntryQueryReq, BaseCollectionModel<CalendarEntryRes>>(
            `${this.segment}/entries/search`,
            CalendarEntryRes,
            query
        );
    }

    /** POST /calendar/entries */
    public create(dto: CalendarEntryCreateTypedReq) {
        // forward dto as-is
        return this.api.post<CalendarEntryCreateTypedReq, BaseCollectionModel<CalendarEntryRes>>(
            `${this.segment}/entries`,
            CalendarEntryRes,
            dto
        );
    }

    /** POST /calendar/entries/batch */
    public createBatch(dto: CalendarEntryCreateBatchReq) {
        return this.api.post<CalendarEntryCreateBatchReq, BaseCollectionModel<CalendarEntryRes>>(
            `${this.segment}/entries/batch`,
            CalendarEntryRes,
            dto
        );
    }

    /** PATCH /calendar/entries */
    public update(dto: CalendarEntryUReq) {
        return this.api.patch<CalendarEntryUReq, BaseCollectionModel<CalendarEntryRes>>(
            `${this.segment}/entries`,
            CalendarEntryRes,
            dto
        );
    }

    /** DELETE /calendar/entries/{id} */
    public delete(id: number, applyToGroup: boolean = false) {
        // depending on your RestApiService signature, this might be:
        // return this.api.delete<void>(`${this.segment}/entries/${id}`);
        let qp = {
            "applyToGroup": applyToGroup
        };
        return this.api.delete<void>(`${this.segment}/entries/${id}`, qp);
    }

    /** PATCH /calendar/invitations/respond */
    public respondInvitation(dto: CalendarInvitationRespondReq) {
        return this.api.patch<CalendarInvitationRespondReq, CalendarEntryRes>(
            `${this.segment}/invitations/respond`,
            CalendarEntryRes,
            dto
        );
    }

    /** Get /calendar/statistics */
    public getStatistics(query: CalendarStatsQueryReq) {
        return this.api.get<CalendarYearStatContractRes>(
            `${this.segment}/statistics`,
            CalendarYearStatContractRes,
            query
        );
    }

    /** Get /calendar/approvals/pending */
    public getSearchApprovals(searchReq?:CalendarApprovalSearchReq) {
        return this.api.post<CalendarApprovalSearchReq,BaseCollectionModel<CalendarEntryRes>>(
            `${this.segment}/approvals/search`,
            CalendarEntryRes,
            searchReq
        );
    }

    /** Patch /calendar/approvals/batch */
    public approveBatch(req: CalendarApprovalBatchReq) {
        return this.api.patch<CalendarApprovalBatchReq, BaseCollectionModel<CalendarEntryRes>>(
            `${this.segment}/approvals/batch`,
            CalendarEntryRes,
            req
        );
    }

    /** Post /calendar/entries/missing */
    public getMissingEntries(searchReq?: CalendarMissingEntrySearchReq) {
        return this.api.post<CalendarMissingEntrySearchReq, BaseCollectionModel<CalendarMissingEntriesUserRes, CalendarMissingEntriesAggregationRes, CalendarMissingEntriesGroupingRes>>(
            `${this.segment}/entries/missing`,
            CalendarMissingEntriesUserRes,
            searchReq
        )
    }
}